import React, { Component } from "react";
import _ from "lodash";
import ModalOrdonnance from "./ModalOrdonnance";
import { Service } from "../../../../../service/service";
import { API } from "../../../../../../const";
import { withTranslation } from 'react-i18next';

class TreatementItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ordonnanceState: false,
      deletemodal: false,
      ordonnanceList: [],
    };
    this.showordonnanceModal = this.showordonnanceModal.bind(this);
    this.handleCloseDelete = this.handleCloseDelete.bind(this);
    this.updateTreatement = this.updateTreatement.bind(this);
  }
  showordonnanceModal = (e) => {
    e.preventDefault();
    let tok = localStorage.getItem("token");
    var kidsId = this.props.kidItem.id;
    const response = Service.get(
      `${API}api/enfant/creche/enfants/${kidsId}/dossier-medical/ordonnances`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      this.setState({
        ordonnanceList: res.data.ordonnances,
      });
    });
    response.catch((err) => {
      console.log("err", err);
    });
    this.setState({
      ordonnanceState: true,
    });
  };

  handleCloseDelete = () => {
    this.setState({
      deletemodal: false,
      ordonnanceState: false,
    });
  };

  updateTreatement = (data, didChange) => {
    this.props.updateListTreatement(data, this.props.index, didChange);
    this.setState({
      deletemodal: false,
      ordonnanceState: false,
    });
  };

  handlechangeTraitement(e) {
    e.preventDefault();
    var data = {};
    data.name = e.target.name;
    data.value = e.target.value;
    data.index = this.props.index;
    this.props.editTraitement(data);
  }

  render() {
    const { showDeleteModal, editTraitement, t } = this.props;
    return (
      <div>
        <section className="content-section">
          <div className="row align-items-center mb-3">
            <div className="col-md-5">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder={t('modal_enfant.treatment_tab.name_placeholder')}
                  style={{ paddingLeft: 20 }}
                  value={this.props.item.titre || ""}
                  name="EditTraitementName"
                  onChange={(e) => this.handlechangeTraitement(e)}
                />
              </div>
            </div>
            <div className="col-md-5 d-flex align-items-center">
              {!_.isNumber(this.props.item.idOrdonnance) ? (
                <button
                  type="submit"
                  className="btn-gradient btn-valid"
                  style={{ width: 240 }}
                  onClick={(e) => this.showordonnanceModal(e)}
                >
                  {t('modal_enfant.treatment_tab.add_ordonnance')}
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn-gradient btn-valid"
                  style={{ width: 240, background: "#004cc5" }}
                  data-toggle="modal"
                  data-target="#modalOrdonnance"
                  onClick={(e) => this.showordonnanceModal(e)}
                >
                  {t('modal_enfant.treatment_tab.modify_ordonnance')}
                </button>
              )}
            </div>
            <div className="col-md-2 d-flex align-items-center">
              <button
                className="action-line delete"
                onClick={(e) => showDeleteModal(e, this.props.index)}
              />
            </div>
          </div>
          <div className="row align-items-center mb-3">
            <div className="col-md-10">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder={t('modal_enfant.treatment_tab.description_placeholder')}
                  style={{ paddingLeft: 20 }}
                  name="EditTraitementDescription"
                  value={this.props.item.description || ""}
                  onChange={(e) => this.handlechangeTraitement(e)}
                />
              </div>
            </div>
          </div>
        </section>
        {this.state.ordonnanceState === true ? (
          <ModalOrdonnance
            kidItem={this.props.kidItem}
            traitementItem={this.props.item}
            handleCloseDelete={this.handleCloseDelete}
            values={this.state}
            ordonnanceList={this.state.ordonnanceList}
            updateTreatement={this.updateTreatement}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default withTranslation()(TreatementItems);
